var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 7.00024C12.5521 7.00024 12.9998 7.44796 12.9998 8.00024V12.0002C12.9998 12.5525 12.5521 13.0002 11.9998 13.0002C11.4475 13.0002 10.9998 12.5525 10.9998 12.0002V8.00024C10.9998 7.44796 11.4475 7.00024 11.9998 7.00024Z",
    fill: "#EF4F45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 17.0002C12.5521 17.0002 12.9998 16.5525 12.9998 16.0002C12.9998 15.448 12.5521 15.0002 11.9998 15.0002C11.4475 15.0002 10.9998 15.448 10.9998 16.0002C10.9998 16.5525 11.4475 17.0002 11.9998 17.0002Z",
    fill: "#EF4F45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.43478 2.34158C9.97863 1.445 10.9511 0.897461 11.9998 0.897461C13.0484 0.897461 14.0209 1.445 14.5648 2.34158L14.5677 2.34633L23.0376 16.4863L23.0458 16.5001C23.5788 17.4232 23.582 18.5599 23.0541 19.4859C22.5263 20.412 21.5466 20.9884 20.4808 21.0001L20.4698 21.0003L3.51879 21.0002C2.4529 20.9885 1.47329 20.412 0.945426 19.4859C0.417566 18.5599 0.420749 17.4232 0.953786 16.5001L0.961909 16.4863L9.43191 2.34633L9.43478 2.34158ZM11.146 3.37684L2.68246 17.506C2.50808 17.8127 2.50813 18.1888 2.68298 18.4955C2.85817 18.8029 3.18266 18.9947 3.53617 19.0002H20.4634C20.8169 18.9947 21.1414 18.8029 21.3166 18.4955C21.4914 18.1888 21.4915 17.8127 21.3171 17.5061L12.8548 3.37883L12.8536 3.37684C12.6721 3.07916 12.3485 2.89746 11.9998 2.89746C11.651 2.89746 11.3275 3.07916 11.146 3.37684Z",
    fill: "#EF4F45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFail);
export default __webpack_public_path__ + "static/media/fail.00372dd9dbc41693e5df92de12347f80.svg";
export { ForwardRef as ReactComponent };